export default __webpack_public_path__ + "static/media/litecampus-pin-grey.15e9a7ac.svg";